import { useMemo } from "react";
import { useHotelRoomCard as useCoreHotelRoomCard } from "@b2bportal/core-hotels";
import { Funnel } from "@b2bportal/core-types";
import { useI18nContext } from "@hopper-b2b/i18n";
import { useGetCurrentFunnel } from "@overrides/utilities";
import type { HotelRoomCardComponentProps } from "@tenant/hotels";
import { useHotelRoomNightlyPricing } from "../HotelRoomCardRates";

export const useHotelRoomCard = ({
  room,
  onRoomSelection,
  nightCount,
}: HotelRoomCardComponentProps) => {
  const { t } = useI18nContext();
  const currFunnel = useGetCurrentFunnel();
  const isInPackagesFlow = currFunnel === Funnel.Package;

  const { context, handlers, text, rateSelection } = useCoreHotelRoomCard({
    room,
    onRoomSelection,
    nightCount,
  });

  const { nightlyPrice, nightlyPoints, showPointsPricing } =
    useHotelRoomNightlyPricing({
      selectedProduct: context.selectedRate.product,
    });

  return useMemo(() => {
    // In packages flow, just show "Select"
    const roomCTA = isInPackagesFlow
      ? t("select")
      : showPointsPricing
        ? t("core-hotels.roomSelection.cta.points", { points: nightlyPoints })
        : t("core-hotels.roomSelection.cta.cash", { price: nightlyPrice });

    return {
      context,
      handlers,
      text: {
        ...text,
        roomCTA,
      },
      rateSelection,
    };
  }, [
    context,
    isInPackagesFlow,
    showPointsPricing,
    t,
    nightlyPoints,
    nightlyPrice,
    handlers,
    text,
    rateSelection,
  ]);
};
